// extracted by mini-css-extract-plugin
module.exports = {"dataChart":"AllCharts_dataChart__2hqKm","dataChartNarrow":"AllCharts_dataChartNarrow__3tX_t","chartInnerCard":"AllCharts_chartInnerCard__3qVUH"};